export default function formatDate(date) {
  if (date === undefined || date === null) {
    return 'NULL';
  }
  const onlyDate = date.slice(0, 10);
  const splittedDate = onlyDate.split('-');

  return `${splittedDate[2]}/${splittedDate[1]}/${splittedDate[0]}`;
}
